import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/logo.png';
var _hoisted_1 = {
  "class": "update-dialog"
};
var _hoisted_2 = {
  "class": "update-title"
};
var _hoisted_3 = {
  "class": "update-desc"
};
var _hoisted_4 = {
  key: 0,
  "class": "update-progress-wrap"
};
var _hoisted_5 = {
  "class": "update-progress-bar"
};
var _hoisted_6 = {
  "class": "update-progress-text"
};
var _hoisted_7 = {
  "class": "update-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    closable: _ctx.closable,
    "mask-closable": false,
    footer: null,
    width: "400px",
    centered: "",
    "wrap-class-name": "update-dialog-modal"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        "class": "update-icon"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        "class": "update-logo"
      })], -1)), _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1), _ctx.showProgress ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        "class": "update-progress-fill",
        style: _normalizeStyle({
          width: _ctx.progressPercent + '%'
        })
      }, null, 4)]), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.progressPercent) + "%", 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_ctx.showDownloadBtn ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        type: "primary",
        block: "",
        onClick: _ctx.startDownload
      }, {
        "default": _withCtx(function () {
          return _cache[0] || (_cache[0] = [_createTextVNode(" 立即更新 ", -1)]);
        }),
        _: 1,
        __: [0]
      }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.showLaterBtn ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        block: "",
        onClick: _ctx.closeDialog
      }, {
        "default": _withCtx(function () {
          return _cache[1] || (_cache[1] = [_createTextVNode(" 稍后提醒 ", -1)]);
        }),
        _: 1,
        __: [1]
      }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.showRestartBtn ? (_openBlock(), _createBlock(_component_a_button, {
        key: 2,
        type: "primary",
        block: "",
        onClick: _ctx.restartApp
      }, {
        "default": _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createTextVNode(" 立即重启 ", -1)]);
        }),
        _: 1,
        __: [2]
      }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.showManualBtn ? (_openBlock(), _createBlock(_component_a_button, {
        key: 3,
        block: "",
        onClick: _ctx.closeDialog
      }, {
        "default": _withCtx(function () {
          return _cache[3] || (_cache[3] = [_createTextVNode(" 知道了 ", -1)]);
        }),
        _: 1,
        __: [3]
      }, 8, ["onClick"])) : _createCommentVNode("", true)])])];
    }),
    _: 1
  }, 8, ["visible", "closable"]);
}